<template>
    <v-card class="scrollable-container elevation-5">
        <v-card-title>
            <v-container fluid pa-0>
                <v-row no-gutters class="text-center">
                    <v-col class="pb-2"
                        >Please choose your venue ({{ venuesCount }})</v-col
                    >
                </v-row>
                <v-row no-gutters>
                    <v-col class="pb-1">
                        <v-text-field
                            v-model="filterQuery"
                            label="Venue filter"
                            placeholder="Enter a venue name"
                            clearable
                            outlined
                            hide-details
                            data-cy="field-search"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-title>
        <v-card-text class="scrollable-content">
            <v-container fluid pa-0>
                <v-row>
                    <v-col
                        v-for="venue in filteredVenues"
                        :key="venue.venue.identifier"
                        md="3"
                        cols="6"
                    >
                        <v-hover>
                            <v-card
                                slot-scope="{ hover }"
                                elevation="10"
                                class="venue-card"
                                :class="{
                                    'selected-venue': isVenueSelected(venue),
                                    'hover-on': hover
                                }"
                                :color="venueCardColor"
                                @click="onVenueClick(venue)"
                                @keyup.enter="onVenueClick(venue)"
                            >
                                <v-card-title class="py-1">
                                    <div class="text-h6">
                                        {{ venue.venue.title }}
                                    </div>
                                </v-card-title>
                                <v-card-text class="pt-4">
                                    <v-img
                                        v-if="venueLogo(venue)"
                                        :src="venueLogo(venue)"
                                        :alt="venue.venue.title"
                                        class="branding mx-3"
                                        height="40px"
                                        position="left center"
                                        contain
                                    >
                                        <template v-slot:placeholder>
                                            <div
                                                class="text-h5 font-italic font-weight-bold "
                                            >
                                                {{ venue.venue.identifier }}
                                            </div>
                                        </template>
                                    </v-img>
                                </v-card-text>
                            </v-card>
                        </v-hover>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { isEmpty } from '@/common/helpers';

export default {
    name: 'VenueSwitcherPage',
    data() {
        return {
            filterQuery: '',
            assetsPath: '/assets/images/logos/hotels/'
        };
    },
    computed: {
        ...mapState('authUser', ['userScopeOptions']),
        ...mapGetters('venue', ['currentVenue']),
        venuesCount() {
            return this.filteredVenues.length;
        },
        filteredVenues() {
            if (this.filterQuery && this.filterQuery.trim()) {
                const re = new RegExp(this.filterQuery, 'i');
                return this.userScopeOptions.filter(item => {
                    return (
                        re.test(item.venue.title) ||
                        re.test(item.venue.identifier)
                    );
                });
            }
            return this.userScopeOptions;
        },
        venueCardColor() {
            if (this.$vuetify.theme.isDark) {
                return '';
            }
            return 'deep-grey darken-2';
        }
    },
    methods: {
        ...mapActions('venue', ['saveSelectedVenue', 'fetchVenueInfo']),
        // ===================== Events ===================================
        async onVenueClick(venue) {
            await this.saveSelectedVenue(venue);
            await this.fetchVenueInfo();
            if (this.$router.currentRoute.query.redirect) {
                this.$router.push(this.$router.currentRoute.query.redirect);
            } else {
                this.$router.push({ name: 'homePage' });
            }
        },
        // ====================== Others ===================================
        venueIcon(venue) {
            switch (venue.partner.partnerType) {
                case 'Hotel':
                    return this.icons.space;
                case 'Venue':
                    return this.icons.college;
                default:
                    return this.icons.business;
            }
        },
        isVenueSelected(venue) {
            return venue.venue.identifier === this.currentVenue;
        },
        venueLogo(venue) {
            if (!isEmpty(venue) && !isEmpty(venue.venue)) {
                return `${this.assetsPath}${venue.venue.identifier}.svg`;
            } else {
                return '';
            }
        }
    }
};
</script>

<style scoped lang="scss">
.theme--light.hover-on,
.theme--light.venue-card:focus {
    .v-card__title,
    .v-card__text {
        color: var(--v-secondary-lighten4) !important;
    }
    .branding {
        -moz-box-shadow: 0 0 10px var(--v-secondary-lighten4);
        -webkit-box-shadow: 0 0 10px var(--v-secondary-lighten4);
        box-shadow: 0 0 10px var(--v-secondary-lighten4);
    }
}
.theme--light.venue-card .v-card__title {
    color: #ffffff !important;
}
.theme--light.selected-venue {
    .v-card__title {
        color: var(--v-secondary-lighten4) !important;
    }
}

.theme--dark.hover-on,
.theme--dark.venue-card:focus {
    .v-card__title,
    .v-card__text {
        color: var(--v-secondary-base) !important;
    }
    .branding {
        -moz-box-shadow: 0 0 10px var(--v-secondary-base);
        -webkit-box-shadow: 0 0 10px var(--v-secondary-base);
        box-shadow: 0 0 10px var(--v-secondary-base);
    }
}
.theme--dark.selected-venue {
    .v-card__title {
        color: var(--v-secondary-base) !important;
    }
}
</style>
